//NHCC V2.0 api base url
export const basePathApi = process.env.REACT_APP_API_URL;
export const basePathApiGolang = process.env.REACT_APP_GOLANG_API_URL;

// export const basePathApi = "https://apistaging-nhcc.kakashi.app/api/v2/";
